import { AppNotification } from '../models/Notification';
import { NotificationRepository } from '../repositories/NotificationRepository';
import { logger } from '@/src/core/utils';

export class GetNotificationsUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(userId: string, limit: number = 20, offset: number = 0): Promise<AppNotification[]> {
    logger.debug('GetNotifications', 'Fetching notifications', { userId });
    const notifications = await this.notificationRepository.getNotifications(userId, limit, offset);
    logger.debug('GetNotifications', 'Fetched notifications', { count: notifications.length });
    return notifications;
  }
}
